import React, {useEffect, useState} from "react"
import useGoogleSheets from "use-google-sheets"
import ReactPlayer from "react-player"
import LoadingSpinner from "./LoadingSpinner/LoadingSpinner"
import { recordEvent } from '../apis/googleAnalytics'
import LanguageCodes from '../data/languageCodes.json'

const SphereViewVideo = ({ language, version, id }) => {
  console.log("SphereViewVideo", id)
  const [showTranscript, setShowTranscript] = useState(false)
  const { data, loading, error } = useGoogleSheets({
    apiKey: "AIzaSyAb_P06-faYkzrsHqYvF7us6kBdfyIpY6M",
    sheetId: "1dHiHr64uZ8pFUjY_mDqOD8SAQtdTxNtKSDjN4AFcy4U",
    sheetsNames: [language],
  })

  const videos = data && data[0] ? data[0].data : null
  const selectedVideo = videos ? videos.find(b => b["ID"] === id) : null
  const urls = selectedVideo ? [selectedVideo["YouTubeURL"]] : null
  const { transcript } = selectedVideo ? selectedVideo : {}

  useEffect(() => {
    if ((!urls || !urls[0]) && transcript && !showTranscript) {
      setShowTranscript(true)
    }
  }, [transcript])

  if (loading) {
    return null
  }

  if (error) {
    console.log(error)
    return null
  }

  if ((!urls || !urls[0]) && !transcript) return null

  if ((!urls || !urls[0]) && transcript) {
    // setShowTranscript(true);
    return (
      <div>
        {showTranscript ? (
          <div
            style={{
              margin: "10px",
              position: "relative",
              whiteSpace: "pre-line",
            }}
          >
            <p>{transcript}</p>
            <p
              style={{ color: "blue" }}
              onClick={() => setShowTranscript(false)}
            >
              Hide transcript...
            </p>
          </div>
        ) : (
          <p style={{ color: "blue" }} onClick={() => setShowTranscript(true)}>
            Show transcript...
          </p>
        )}
      </div>
    )
  }

  // setShowRR(true)
  return urls
    ? urls.map(url => {
      console.log("url", url)
        return (
          <div>
            <div
              style={{
                margin: "10px 0 10px 0",
                display: "flex",
                justifyContent: "center",
                position: "relative",
                paddingTop: "56.25%", // 720 / 1280 = 0.5625 //
              }}
              key={url}
            >
              <ReactPlayer
                url={url}
                config={{
                  youtube: {
                    playerVars: {
                      hl: LanguageCodes[language.toLowerCase()],
                      cc_load_policy: 1,
                    },
                  },
                }}
                controls
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  display: "block",
                }}
                width="100%"
                height="100%"
                onStart={() =>
                  recordEvent("SphereView Video", `${language}-${version}`, id)
                }
              />
            </div>
            {transcript ? (
              <div
                style={{
                  margin: "10px",
                  position: "relative",
                  whiteSpace: "pre-line",
                }}
              >
                {showTranscript ? (
                  <div>
                    <p>{transcript}</p>
                    <p
                      style={{ color: "blue" }}
                      onClick={() => setShowTranscript(false)}
                    >
                      Hide transcript...
                    </p>
                  </div>
                ) : (
                  <p
                    style={{ color: "blue" }}
                    onClick={() => setShowTranscript(true)}
                  >
                    Show transcript...
                  </p>
                )}
              </div>
            ) : null}
          </div>
        )})
    : null
}

export default SphereViewVideo